function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import React from 'react';
import styled from 'styled-components';
import { fontRegular, fontSemiBold } from '../../theme/fonts';
import { size12, size14, size16 } from '../../theme/scale';
import ColorWrapper from '../color-wrapper';
const getSerifFontFromWeight = weight => weight === 'regular' ? fontRegular : fontSemiBold;
const Wrapper = styled(ColorWrapper)`
  font-size: ${size16};
  line-height: 1.5;
  font-family: ${({
  weight
}) => getSerifFontFromWeight(weight)};
  ${({
  sm
}) => sm && `font-size: ${size14}; line-height: 1.3;`}
  ${({
  xs
}) => xs && `font-size: ${size12}; line-height: 1.3;`}
  ${({
  marginBottom
}) => marginBottom && `margin-bottom: ${size16};`}
`;
export const Body = ({
  children,
  element = 'p',
  xs = false,
  sm = false,
  marginBottom = false,
  weight = 'regular',
  ...props
}) => /*#__PURE__*/React.createElement(Wrapper, _extends({
  as: element,
  xs,
  sm,
  marginBottom,
  weight
}, props), children);
export default Body;
//# sourceMappingURL=index.js.map